// extracted by mini-css-extract-plugin
export default {"container":"form-control_container__2yDv5","label":"form-control_label__3lPHK","errors":"form-control_errors__2w4HK","isRequired":"form-control_isRequired__1bYc3"};